export default __webpack_public_path__ + "static/media/sam-logo.f0da32f6.png";